import React, { FC } from 'react';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import clsx from 'clsx';

interface SwitcherProps {
  value: string;
  items: Array<{
    title: string;
    value: string;
  }>;
  onChange: (value: string) => void;
}

const Switcher: FC<SwitcherProps> = (props) => {
  const { items, value, onChange } = props;
  const onSelect = (newValue: string) => () => onChange(newValue);
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root}>
      {items.map((item) => (
        <button
          key={item.value}
          className={clsx(styles.button, item.value === value && styles.active)}
          onClick={onSelect(item.value)}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    width: 100%;
    display: flex;
    background-color: #f6f6f7;
    border-radius: 6px;
    padding: 3px;
    margin-bottom: 12px;
  `,
  button: css`
    background: none;
    border: none;
    outline: none;
    width: 50%;
    border-radius: 6px;
    height: 46px;
    color: #acafb3;
    cursor: pointer;
    font-weight: 600;
    font-size: 18px;
    line-height: 130%;
  `,
  active: css`
    color: #fff;
    background-color: ${theme.colors.accent};
    cursor: default;
  `,
});

export default Switcher;
